// extracted by mini-css-extract-plugin
module.exports = {"form":"Checkout_form__3BeKe","control":"Checkout_control__1EWil","actions":"Checkout_actions__2Lovk","submit":"Checkout_submit__2hGQY","invalid":"Checkout_invalid__2DMUL"};